import React from 'react';
import { Eyebrow, Heading, Text } from '@atlassian/learning-components';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { media } from '@atlaskit/primitives/responsive';

import heroDesktopImage from 'src/assets/images/landings/learningPathLandingHeroDesktop.svg';

interface HeroProps {
  title: string;
  subtitle: string;
  eyebrowText?: string;
  bottomImageSrc?: string;
  showHeroDesktopImage?: boolean;
}

export const Hero: React.FC<HeroProps> = ({
  title,
  subtitle,
  eyebrowText,
  bottomImageSrc,
  showHeroDesktopImage = false,
}) => (
  <>
    <section css={heroStyles} data-testid="hero">
      {showHeroDesktopImage && (
        <img css={heroDesktopImageStyles} src={`${heroDesktopImage}`} alt="hero-image-desktop" role="presentation" />
      )}
      {eyebrowText && eyebrowText.length > 0 && (
        <div css={eyebrowContainerStyles} data-testid="hero-eyebrow-text">
          <Eyebrow size="medium" fontWeight="semibold" color={token('color.text.subtle')}>
            {eyebrowText}
          </Eyebrow>
        </div>
      )}
      <div css={headerStyles} data-testid="hero-title">
        <Heading level={0}>{title}</Heading>
      </div>
      <div css={subtitleStyles} data-testid="hero-subtitle">
        <Text size="large">{subtitle}</Text>
      </div>
    </section>
    {bottomImageSrc && <img css={heroImageStyles} src={bottomImageSrc} alt="hero-image" role="presentation" />}
  </>
);

const heroStyles = css({
  width: '100%',
  height: '100%',
  maxWidth: '1022px',
  display: 'flex',
  marginTop: token('space.600'),
  marginBottom: token('space.600'),
  padding: `0 ${token('space.300')}`,
  flexDirection: 'column',
  alignItems: 'flex-start',

  [media.below.xs]: {
    marginTop: token('space.500'),
    marginBottom: token('space.500'),
    padding: `0 ${token('space.200')}`,
  },
});

const eyebrowContainerStyles = css({
  marginBottom: token('space.200'),
});

const headerStyles = css({
  marginBottom: token('space.200'),
});

const subtitleStyles = css({
  maxWidth: '720px',
});

const heroDesktopImageStyles = css({
  position: 'absolute',
  width: '500px',
  height: '400px',
  top: '-5px',
  right: '0',

  [media.below.md]: {
    display: 'none',
  },
});

const heroImageStyles = css({
  maxWidth: '1440px',

  [media.below.md]: {
    alignSelf: 'stretch',
  },
});
